import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "overflow-hidden py-8" }
const _hoisted_2 = {
  class: "relative -rotate-2 scale-105 overflow-hidden border-y border-copper/20 bg-gradient-to-r from-copper-deep via-copper to-copper-deep py-5",
  "aria-hidden": "true"
}
const _hoisted_3 = { class: "flex w-max animate-marquee" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "text-lg text-ink/50" }, "✦", -1)

import { services } from "@/data/services";


export default /*#__PURE__*/_defineComponent({
  __name: 'MarqueeComponent',
  setup(__props) {

const items = services.map((s) => s.title);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([..._unref(items), ..._unref(items)], (item, i) => {
          return (_openBlock(), _createElementBlock("span", {
            key: i,
            class: "flex items-center gap-10 pr-10 font-display text-2xl font-bold uppercase tracking-widest text-ink md:text-3xl"
          }, [
            _createTextVNode(_toDisplayString(item) + " ", 1),
            _hoisted_4
          ]))
        }), 128))
      ])
    ])
  ]))
}
}

})